<div class="event-modal__header-container">
  <dcc-page-title title="Events"></dcc-page-title>
  <div type="button"
       (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </div>
</div>

<div class="event-modal__date-selector">
  <div class="event-modal__date-selector__start">
    <label for="meeting-time">Start Date</label>
    <input type="datetime-local" id="start-date" name="start-date" [(ngModel)]="startDate" (change)="onDateChange()">
  </div>

  <div class="event-modal__date-selector__end">
    <label for="meeting-time">End Date</label>
    <input type="datetime-local" id="end-date" name="end-date" [(ngModel)]="endDate" (change)="onDateChange()">
  </div>
</div>

<div class="grid-container">
  <div class="grid-container__top">
    <dcc-billboard label="Events"
                   [value]="events.length"
                   direction="row"></dcc-billboard>
    <button *ngIf="canRequestEvents" class="lx-btn-small lx-btn-primary" (click)="requestEvents()" [disabled]="!isRequestEventsEnabled()">Request Events</button>
  </div>
  <ag-grid-angular style="width: auto; height: 100%"
                   class="ag-theme-alpine ag-grid-sticky-header ag-grid-container"
                   [columnDefs]="columnDefs"
                   [defaultColDef]="defaultColDef"
                   [suppressRowHoverHighlight]="true"
                   [enableCellTextSelection]="true"
                   [ensureDomOrder]="true"
                   domLayout="autoHeight"
                   [rowSelection]="'multiple'"
                   [isRowSelectable]="isRowSelectable"
                   [rowMultiSelectWithClick]="true"
                   (gridReady)="onGridReady($event)"></ag-grid-angular>
</div>

<button class="lx-btn lx-btn-secondary close-button"
        (click)="close()">Close</button>
